"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CUSTOM_JS_WRITE = exports.CUSTOM_JS_READ = exports.EVENTS_WRITE = exports.EVENTS_READ = exports.ANALYTICS_VIEWS_WRITE = exports.ANALYTICS_VIEWS_READ = exports.ANALYTICS_SETTINGS_WRITE = exports.ANALYTICS_SETTINGS_READ = exports.ANALYTICS_ADVANCED_SETTINGS_WRITE = exports.ANALYTICS_ADVANCED_SETTINGS_READ = void 0;
var ANALYTICS_ADVANCED_SETTINGS_READ = 'analytics-advanced-settings-read';
exports.ANALYTICS_ADVANCED_SETTINGS_READ = ANALYTICS_ADVANCED_SETTINGS_READ;
var ANALYTICS_ADVANCED_SETTINGS_WRITE = 'analytics-advanced-settings-write';
exports.ANALYTICS_ADVANCED_SETTINGS_WRITE = ANALYTICS_ADVANCED_SETTINGS_WRITE;
var ANALYTICS_SETTINGS_READ = 'analytics-settings-read';
exports.ANALYTICS_SETTINGS_READ = ANALYTICS_SETTINGS_READ;
var ANALYTICS_SETTINGS_WRITE = 'analytics-settings-write';
exports.ANALYTICS_SETTINGS_WRITE = ANALYTICS_SETTINGS_WRITE;
var ANALYTICS_VIEWS_READ = 'analytics-filters-read';
exports.ANALYTICS_VIEWS_READ = ANALYTICS_VIEWS_READ;
var ANALYTICS_VIEWS_WRITE = 'analytics-filters-write';
exports.ANALYTICS_VIEWS_WRITE = ANALYTICS_VIEWS_WRITE;
var EVENTS_READ = 'events-analytics';
exports.EVENTS_READ = EVENTS_READ;
var EVENTS_WRITE = 'events-analytics-write';
exports.EVENTS_WRITE = EVENTS_WRITE;
var CUSTOM_JS_READ = 'custom-javascript-events-read';
exports.CUSTOM_JS_READ = CUSTOM_JS_READ;
var CUSTOM_JS_WRITE = 'custom-javascript-events-write';
exports.CUSTOM_JS_WRITE = CUSTOM_JS_WRITE;
var _default = [ANALYTICS_ADVANCED_SETTINGS_READ, ANALYTICS_ADVANCED_SETTINGS_WRITE, ANALYTICS_SETTINGS_READ, ANALYTICS_SETTINGS_WRITE, EVENTS_WRITE, CUSTOM_JS_READ, CUSTOM_JS_WRITE];
exports.default = _default;